import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaInstagram, FaTelegram, FaTwitter, FaGlobe, FaFacebook } from "react-icons/fa";

const socialAccounts = [
  {
    id: 1,
    type: "instagram",
    title: "Instagram",
    username: "@velvet.store.uz",
    desc: "Bizning eng so'nggi kolleksiyalarimizni ko'ring va eng yangi trendlardan xabardor bo'ling.",
    followers: "5796",
    link: "https://www.instagram.com/velvet.store.uz/?hl=en",
    icon: <FaInstagram size={40} />,
    color: "#C13584",
    gradient:
      "linear-gradient(45deg, #405DE6, #5851DB, #833AB4, #C13584, #E1306C, #FD1D1D)",
  },
  {
    id: 2,
    type: "telegram",
    title: "Telegram",
    username: "@velvet_shoes",
    desc: "Bizning Telegram kanalimizga qo'shiling va maxsus takliflar va chegirmalardan birinchi bo'lib xabardor bo'ling.",
    followers: "518",
    link: "https://t.me/+EJTyMYqdrLY5MWVi",
    icon: <FaTelegram size={40} />,
    color: "#0088cc",
    gradient: "linear-gradient(135deg, #0088cc, #33a3dc)",
  },
  // {
  //   id: 3,
  //   type: "twitter",
  //   title: "Twitter",
  //   username: "@velvet_shoes",
  //   desc: "Bizning Twitter sahifamizni kuzating va eng so'nggi yangiliklar va e'lonlardan xabardor bo'ling.",
  //   followers: "3.8K",
  //   link: "https://twitter.com/your_username",
  //   icon: <FaTwitter size={40} />,
  //   color: "#1DA1F2",
  //   gradient: "linear-gradient(135deg, #1DA1F2, #65c9ff)",
  // },
  // {
  //   id: 4,
  //   type: "facebook",
  //   title: "Facebook",
  //   username: "Velvet Shoes",
  //   desc: "Bizning Facebook sahifamizga qo'shiling va hamjamiyatimiz bilan bog'laning.",
  //   followers: "8.3K",
  //   link: "https://facebook.com/your_page",
  //   icon: <FaFacebook size={40} />,
  //   color: "#4267B2",
  //   gradient: "linear-gradient(135deg, #4267B2, #5d82d1)",
  // },
];

const PricingPlans = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [counters, setCounters] = useState({});

  useEffect(() => {
    // Initialize counters for animation
    const initialCounters = {};
    socialAccounts.forEach(account => {
      initialCounters[account.id] = 0;
    });
    setCounters(initialCounters);
  }, []);

  useEffect(() => {
    // Animate follower counts
    const interval = setInterval(() => {
      setCounters(prevCounters => {
        const newCounters = { ...prevCounters };
        
        socialAccounts.forEach(account => {
          const targetValue = parseInt(account.followers.replace(/[^0-9.]/g, ''));
          if (newCounters[account.id] < targetValue) {
            newCounters[account.id] = Math.min(newCounters[account.id] + Math.ceil(targetValue / 20), targetValue);
          }
        });
        
        return newCounters;
      });
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="social-accounts-section py-5" id="social-media" style={{ 
      background: "linear-gradient(135deg, #173222, #1a3c29)",
      padding: "80px 0"
    }}>
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center mb-5">
            {/* - Section Heading - */}
            <div className="section-heading">
              <div className="sub-heading">
                <p style={{ color: "#d4c19c", letterSpacing: "2px", fontWeight: "500" }}>BIZNI KUZATING</p>
              </div>
              <div className="heading-title">
                <h2 style={{ color: "#ffffff", fontSize: "2.5rem", marginBottom: "20px" }}>Ijtimoiy tarmoqlarda biz bilan bog'laning</h2>
              </div>
              <div className="heading-description">
                <p style={{ color: "#e0e0e0", fontSize: "1.1rem" }}>Eng so'nggi yangiliklar, maxsus takliflar va yangi kolleksiyalardan birinchi bo'lib xabardor bo'ling</p>
              </div>
            </div>
            {/* - Section Heading - */}
          </Col>
        </Row>
        
        {/* - Social Media Accounts - */}
        <Row className="justify-content-center">
          {socialAccounts.map((account) => (
            <Col key={account.id} lg={3} md={6} className="mb-4">
              <div
                className="social-account-card"
                onMouseEnter={() => setHoveredCard(account.id)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{
                  background: hoveredCard === account.id ? account.gradient : "#ffffff",
                  borderRadius: "15px",
                  padding: "30px 25px",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  transform: hoveredCard === account.id ? "translateY(-10px)" : "translateY(0)",
                  position: "relative",
                  overflow: "hidden"
                }}
              >
                {/* Background pattern */}
                <div style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  width: "150px",
                  height: "150px",
                  background: hoveredCard === account.id ? "rgba(255,255,255,0.1)" : `${account.color}10`,
                  borderRadius: "0 0 0 100%",
                  zIndex: "0"
                }}></div>
                
                <div style={{ position: "relative", zIndex: "1" }}>
                  {/* Icon */}
                  <div className="social-icon mb-4" style={{ 
                    color: hoveredCard === account.id ? "#ffffff" : account.color,
                    transition: "all 0.3s ease"
                  }}>
                    {account.icon}
                  </div>
                  
                  {/* Title */}
                  <h3 style={{ 
                    fontSize: "1.5rem", 
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: hoveredCard === account.id ? "#ffffff" : "#173222",
                    transition: "all 0.3s ease"
                  }}>
                    {account.title}
                  </h3>
                  
                  {/* Username */}
                  <p style={{ 
                    fontSize: "1rem", 
                    fontWeight: "500",
                    marginBottom: "15px",
                    color: hoveredCard === account.id ? "rgba(255,255,255,0.9)" : account.color,
                    transition: "all 0.3s ease"
                  }}>
                    {account.username}
                  </p>
                  
                  {/* Followers count */}
                  <div className="followers-count mb-3" style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    marginBottom: "20px"
                  }}>
                    <span style={{ 
                      fontSize: "2rem", 
                      fontWeight: "700",
                      color: hoveredCard === account.id ? "#ffffff" : account.color,
                      transition: "all 0.3s ease"
                    }}>
                      {counters[account.id]?.toLocaleString()}
                    </span>
                    <span style={{ 
                      marginLeft: "5px", 
                      fontSize: "1rem",
                      color: hoveredCard === account.id ? "rgba(255,255,255,0.8)" : "#666",
                      transition: "all 0.3s ease"
                    }}>
                      Obunachilar
                    </span>
                  </div>
                  
                  {/* Description */}
                  <p style={{ 
                    fontSize: "0.9rem", 
                    lineHeight: "1.6",
                    marginBottom: "25px",
                    color: hoveredCard === account.id ? "rgba(255,255,255,0.9)" : "#666",
                    transition: "all 0.3s ease",
                    height: "70px",
                    overflow: "hidden"
                  }}>
                    {account.desc}
                  </p>
                  
                  {/* Action button */}
                  <a 
                    href={account.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      padding: "12px 25px",
                      borderRadius: "30px",
                      fontWeight: "600",
                      textDecoration: "none",
                      textAlign: "center",
                      transition: "all 0.3s ease",
                      background: hoveredCard === account.id ? "#ffffff" : account.color,
                      color: hoveredCard === account.id ? account.color : "#ffffff",
                    }}
                  >
                    Obuna bo'lish
                  </a>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        {/* Call to action */}
        <Row className="mt-5">
          <Col lg={12} className="text-center">
            <p style={{ color: "#d4c19c", fontSize: "1.1rem", marginBottom: "20px" }}>
              Bizning ijtimoiy tarmoqlarimizda siz bilan bog'lanishdan mamnun bo'lamiz
            </p>
            <div className="social-icons-container" style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
              {socialAccounts.map(account => (
                <a 
                  key={account.id}
                  href={account.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: account.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ffffff",
                    transition: "all 0.3s ease",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 5px 15px rgba(0,0,0,0.1)";
                  }}
                >
                  {account.icon}
                </a>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PricingPlans;
